import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "title", "subTitle", "size", "align", "reverse", "titleTagName"];
import React, { forwardRef } from 'react';
import { cnBem } from '@carnica/utils';
import { Text } from "../Text";
import { subTitleSizeMap, titleSizeMap, titleTagMap } from "./utils";
import styles from "./styles.pcss";
var cnTitle = cnBem('title', styles);
export var Title = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
    title = props.title,
    subTitle = props.subTitle,
    _props$size = props.size,
    size = _props$size === void 0 ? 'm' : _props$size,
    _props$align = props.align,
    align = _props$align === void 0 ? 'center' : _props$align,
    _props$reverse = props.reverse,
    reverse = _props$reverse === void 0 ? false : _props$reverse,
    titleTagName = props.titleTagName,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cnTitle({
      size: size,
      reverse: reverse
    }, [className]),
    ref: ref
  }, otherProps), title && /*#__PURE__*/React.createElement(Text, {
    align: align,
    className: cnTitle('title'),
    color: "primary",
    tagName: titleTagName || titleTagMap[size],
    variant: titleSizeMap[size]
  }, title), subTitle && /*#__PURE__*/React.createElement(Text, {
    align: align,
    className: cnTitle('subtitle'),
    color: "secondary",
    tagName: "p",
    variant: subTitleSizeMap[size]
  }, subTitle));
});